module.exports = __webpack_public_path__ + "assets/icons/insights-logo.ebf29b902c194a12f32c9095d1ead2a3.svg";